import cx from 'classix';
import {
  type ChangeEvent,
  type FocusEvent,
  type ReactNode,
} from 'react';

import styles from './select-native.module.scss';

interface SelectNativeProps {
  children: ReactNode;
  label: string;
  name: string;
  emptyDefaultValue?: boolean;
  disabled?: boolean;
  isError?: boolean;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  size?: 'sm' | 'md';
  hideBorder?: boolean;
  className?: string;
  onBlur?: (event: FocusEvent<HTMLSelectElement>) => void;
  value?: string | null;
}

interface OptionProps {
  value: string;
  // selected?: boolean;
  disabled?: boolean;
  children: string;
  label: string;
}

function Option(props: OptionProps) {
  const {
    children,
    disabled,
    label,
    // selected,
    value,
  } = props;

  return (
    <option
      value={value}
      // selected={selected}
      disabled={disabled}
      aria-label={label}
    >
      {children}
    </option>
  );
}

function SelectNative(props: SelectNativeProps) {
  const {
    children,
    className,
    disabled,
    emptyDefaultValue = false,
    hideBorder,
    isError,
    label,
    name,
    onBlur,
    onChange,
    size = 'md',
    value,
  } = props;

  return (
    <div
      className={cx(
        styles.selectNative,
        hideBorder && styles.selectNative__hideBorder,
      )}
    >
      <select
        className={cx(
          styles.selectNative_select,
          styles[`selectNative_select__size-${size}`],
          hideBorder && styles.selectNative_select__hideBorder,
          isError && styles.selectNative_select__isError,
          className,
        )}
        aria-label={label}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        value={value ?? 'emptyDefault'}
      >
        {(emptyDefaultValue || !value) && (
          <Option
            key="emptyDefault"
            value="emptyDefault"
            label="empty default"
            disabled
          >
            {' '}
          </Option>
        )}

        {children}
      </select>
    </div>
  );
}

SelectNative.Option = Option;

export default SelectNative;
